import * as React from 'react';
import { RootContext, UserApiV1InstitutionMenuPath } from '../../../index';

export default class Menu extends React.Component {
  static contextType = RootContext;

  componentDidMount () {
    const ids = location.pathname.split('/').filter(s => s !== '').slice(-3);
    this.context.showLoading();
    this.context.fetch(UserApiV1InstitutionMenuPath(ids[0], ids[2])).then(body => {
      this.setState({ menu: body.result });
    }).finally(() => {
      this.context.hideLoading();
    });
  }

  onClickMenu (url) {
    location.href = url;
  }

  render () {
    console.log(this.state);
    return (
      <div className="p-container p-menus">
        <div className={this.state?.menu ? 'l-conatiner' : 'd-n'}>
          <h4 className="w90p c-mn-title-2 ta-c">{this.context.t('Menu.disclaimer')}</h4>
          <div className="p-container--content">
            {this.context.formatSimple(this.state?.menu?.disclaimer)}
          </div>
          <div className="m-xl">
            <button className="c-mn-btn--first" onClick={ () => { this.onClickMenu(this.state?.menu?.url_location?.new); } }><span>{this.context.t('Menu.next')}</span></button>
          </div>
        </div>
      </div>
    );
  }
}
